export default function initPreloader() {

	const loader = document.querySelector('.preloader')

	if (!loader) return

	let loadingStatus = loader.querySelector('.preloader__status')


	let loadingProgress = 0

	function loading() {
		loadingProgress++
		if (loadingProgress > 100) {
			clearInterval(int)
		} else {
			loadingStatus.innerHTML = `${loadingProgress}%`
		}
	}

	let int = setInterval(loading, 30);

	document.body.classList.add('loading')
	setTimeout(() => {
		document.body.classList.remove('loading')
		document.body.classList.add('loaded')
	}, 4000)

}